import { defineStore } from 'pinia';

export enum AddonsEnum {
  AI_ADDON = 'aiaddon',
  PREMIUM_INTEGRATIONS = 'premium-integrations',
}

export interface Addon {
  id: string;
  addonType: string;
  billingPeriod: string;
  name: string;
}

export interface SubscriptionState {
  id?: string;
  addons?: Addon[];
}

export const useSubscriptionStore = defineStore('subscriptionStore', {
  state: () =>
    ({
      id: undefined,
      addons: undefined,
    }) as SubscriptionState,
  actions: {
    initialize(subscriptionData: any) {
      // Parse addons from subscription data (one request less)
      const addons = subscriptionData.included
        ? subscriptionData.included.reduce((acc: Addon[], item: any) => {
            if (item.type === 'addon') {
              acc.push({
                id: item.id,
                addonType: item.attributes.addonType,
                billingPeriod: item.attributes.billingPeriod,
                name: item.attributes.name,
              });
            }
            return acc;
          }, [])
        : [];

      this.$patch({
        id: subscriptionData.data.id,
        addons,
      });

      return subscriptionData;
    },
  },
  getters: {
    hasAddonOfType: state => (addonType: string) => {
      return state.addons && state.addons.some(addon => addon.addonType === addonType);
    },
  },
});
